export default __webpack_public_path__ + "static/media/monkey-7.60a9e00c.png";